import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12 13.87a.75.75 0 0 1-.75-.75V9.37a.75.75 0 1 1 1.5 0v3.75a.75.75 0 0 1-.75.75M12 17.37a1 1 0 0 1-1-1 1 1 0 0 1 .29-.7 1 1 0 1 1 .71 1.7" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M19.66 21.79H4.34a3.09 3.09 0 0 1-2.68-4.62l7.66-13.4a3.08 3.08 0 0 1 5.36 0l7.66 13.4a3.09 3.09 0 0 1-2.68 4.62M12 3.71a1.58 1.58 0 0 0-1.38.8L3 17.91a1.59 1.59 0 0 0 1.38 2.38h15.28A1.59 1.59 0 0 0 21 17.91l-7.62-13.4a1.58 1.58 0 0 0-1.38-.8" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }